<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       :viewBox="viewBox"
       role="presentation"
       @click="$emit('click')">
    <g :fill="iconColor">
      <slot></slot>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        required: false,
        type: [Number, String],
        default: 18
      },

      height: {
        required: false,
        type: [Number, String],
        default: 18
      },

      viewBox: {
        required: false,
        type: String,
        default: '0 0 100 100'
      },

      iconColor: {
        required: false,
        type: String,
        default: 'currentColor'
      }
    },
  }
</script>
